<template>
  <v-row dense class="DutyActivityNoLineStart_RhB">
    <v-col cols="12">
      {{ time(dutyActivity.fromMinutesAfterMidnight) }} -
      {{ time(dutyActivity.toMinutesAfterMidnight) }}
    </v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';

export default {
  name: 'DutyActivityNoLineStart_RhB',
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  mounted() {
    console.debug('DutyActivityNoLineStart_RhB', JSON.stringify(this.dutyActivity, null, 2));
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
